import * as React from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import GroupAdmin from "../../containers/GroupAdmin";
import { Wrap } from "../../components/Layout/Page";

interface ConnectedProps {
  user: Insite.AppState["auth"]["user"];
}

type Props = ConnectedProps;

function mapStateToProps(state: Insite.AppState) {
  return {
    user: state.auth.user,
  };
}

// NOTE: GroupAdmin is a legacy component.
// TODO: Replace when possible
const GroupAdminScene: React.FC<Props> = ({ user = { access: [] } }) => {
  if (user.access && !user.access.includes("groupAdmin"))
    return <Redirect to="/404" />;
  return (
    <Wrap>
      <GroupAdmin />
    </Wrap>
  );
};

export default connect(mapStateToProps)(GroupAdminScene);
